export const GET_ADDRESS = 'getAddresses';
export const CREATE_ADDRESS = 'createAddress';
export const UPDATE_ADDRESS = 'updateAddress';
export const DELETE_ADDRESS = 'deleteAddress';
export const GET_USER_VISIBLE_COLUMNS = 'getUserVisibleColumns';
